import crypto from 'crypto'

const selected = {
  mediaService: null,
}

export function chooseAOrBVariant(bVariantProbability, userId = null) {
  const bProbability = parseInt(bVariantProbability, 10)

  if (Number.isNaN(bProbability) || bProbability <= 0) {
    return 'A'
  }

  if (bProbability >= 100) {
    return 'B'
  }

  if (!userId) {
    return null
  }

  const hash = crypto
    .createHash('sha256')
    .update(userId)
    .digest('hex')

  // take first 8 hex chars -> 32-bit number
  const num = parseInt(hash.slice(0, 8), 16)
  const bucket = num % 100 // 0–99

  return bucket < bProbability ? 'B' : 'A'
}

function chooseAOrBVariantFromLocalStorage(bVariantProbability, experimentName) {
  const session = JSON.parse(localStorage.getItem('ls.session'))
  if (session?.user) {
    if (selected[experimentName] === null) {
      selected[experimentName] = chooseAOrBVariant(bVariantProbability, session.user)
    }
    return selected[experimentName]
  }
  return 'A'
}

export function shouldPresentBFeature(bVariantProbability, experimentName) {
  return chooseAOrBVariantFromLocalStorage(bVariantProbability, experimentName) === 'B'
}

export function shouldPresentMediaService() {
  return shouldPresentBFeature(process.env.REACT_APP_MEDIASERVICE_USE_PROBABILITY, 'mediaService')
}
